import React, { createContext, useContext, useState, useCallback } from 'react';

const HasChangesContext = createContext();

export const useHasChanges = () => {
  const context = useContext(HasChangesContext);
  if (!context) {
    throw new Error('useHasChanges must be used within a HasChangesProvider');
  }
  return context;
};

export const HasChangesProvider = ({ children }) => {
  const [hasChanges, setHasChanges] = useState(false);

  // Markiert, dass Änderungen vorhanden sind
  const markAsChanged = useCallback(() => {
    setHasChanges(true);
  }, []);

  // Markiert, dass keine Änderungen vorhanden sind (z.B. nach dem Speichern)
  const markAsSaved = useCallback(() => {
    setHasChanges(false);
  }, []);

  // Toggle-Funktion für Testzwecke
  const toggleHasChanges = useCallback(() => {
    setHasChanges(prev => !prev);
  }, []);

  const value = {
    hasChanges,
    markAsChanged,
    markAsSaved,
    toggleHasChanges
  };

  return (
    <HasChangesContext.Provider value={value}>
      {children}
    </HasChangesContext.Provider>
  );
};